export default __webpack_public_path__ + "static/media/nft20.f3d8ed03.png";